// components/Noticias.jsx
import React from 'react';
import Banner from '../assets/banner.jpg';

export default function Noticias() {
  return (
    <section className="bg-gray-100 py-10 px-6">
      <h2 className="text-center text-green-700 text-2xl font-bold mb-8">ÚLTIMAS NOTÍCIAS</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[1, 2, 3].map((n) => (
          <div key={n} className="bg-white rounded shadow p-4">
            <img src={Banner} className="mb-3 rounded" />
            <p className="text-sm text-gray-500">20/06/2025 • Saúde</p>
            <h3 className="font-bold mt-2 text-base">Título da Notícia {n}</h3>
          </div>
        ))}
      </div>
      <div className="text-center mt-6">
        <button className="bg-green-700 text-white px-6 py-2 rounded hover:bg-green-600">VER MAIS NOTÍCIAS</button>
      </div>
    </section>
  );
}